/**
 * AlphaScout UI Utilities — Phase 4
 * Shared helpers for scoring badges, formatting, and styles.
 */

export const scoreColor = (score) => {
  if (score >= 75) return 'text-emerald-400 bg-emerald-500/10 border-emerald-500/30';
  if (score >= 60) return 'text-cyan-400 bg-cyan-500/10 border-cyan-500/30';
  if (score >= 45) return 'text-amber-400 bg-amber-500/10 border-amber-500/30';
  return 'text-gray-400 bg-gray-500/10 border-gray-500/30';
};

export const factorMetaSingular = {
  value: { label: 'Value', color: '#60a5fa' },
  quality: { label: 'Quality', color: '#34d399' },
  momentum: { label: 'Momentum', color: '#fbbf24' },
  technical: { label: 'Technical', color: '#f472b6' },
  smart_money: { label: 'Smart $', color: '#a78bfa' },
  // Session 147j+16 — added so `order_flow` factor (introduced in 147j+7
  // LODR Phase B) no longer crashes PicksTable.FactorBar / FactorRadar /
  // MiniFactorRadar with "Cannot read properties of undefined (reading
  // 'label')".
  order_flow: { label: 'Order Flow', color: '#22d3ee' },
};

export const formatPct = (v, digits = 2) => {
  if (v === null || v === undefined) return '–';
  const sign = v > 0 ? '+' : '';
  return `${sign}${Number(v).toFixed(digits)}%`;
};

export const formatMoney = (v) => {
  if (v === null || v === undefined) return '–';
  return Number(v).toLocaleString('en-IN', { maximumFractionDigits: 2 });
};

export const formatCr = (v) => {
  if (v === null || v === undefined) return '–';
  if (v >= 100000) return `₹${(v / 100000).toFixed(1)}L Cr`;
  return `₹${Math.round(v).toLocaleString('en-IN')} Cr`;
};

export const timeAgo = (iso) => {
  if (!iso) return 'never';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};
